import { Timetable } from '@/core/models/timetable.interface';

export function useWorkCycle() {
   function trimTimeValue(timeValue?: string) {
      if (!timeValue) return;

      return timeValue.slice(0, -3);
   }

   function mapTimetables(timetables: Array<Timetable>, trimTimeValues = false) {
      return [...Array(7)].map((_, index) => {
         const timetable = timetables.find((t) => t.weekday === index + 1);
         if (!timetable) {
            return { weekday: index + 1 } as Timetable;
         }

         const first_start_time = trimTimeValues ? trimTimeValue(timetable?.first_start_time) : timetable?.first_start_time;
         const first_stop_time = trimTimeValues ? trimTimeValue(timetable?.first_stop_time) : timetable?.first_stop_time;
         const second_start_time = trimTimeValues ? trimTimeValue(timetable?.second_start_time) : timetable?.second_start_time;
         const second_stop_time = trimTimeValues ? trimTimeValue(timetable?.second_stop_time) : timetable?.second_stop_time;

         return {
            ...timetable,
            first_start_time,
            first_stop_time,
            second_start_time,
            second_stop_time,
            first_time_range: `${first_start_time} - ${first_stop_time}`,
            second_time_range: second_start_time || second_stop_time ? `${second_start_time} - ${second_stop_time}` : '',
         };
      });
   }

   function formatTimetable(timetable: Timetable) {
      const first_start_time = timetable.first_time_range?.slice(0, 5);
      const first_stop_time = timetable.first_time_range?.slice(8, 13);
      const second_start_time = timetable.second_time_range?.slice(0, 5);
      const second_stop_time = timetable.second_time_range?.slice(8, 13);
      return {
         ...timetable,
         first_start_time,
         first_stop_time,
         second_start_time,
         second_stop_time,
      };
   }

   return { trimTimeValue, mapTimetables, formatTimetable };
}
